import { EApiOfferAgeId } from "utils/offer";
import { QueryValues } from "./queries";

export interface IOfferAgeItemConfig {
  translationId: string; // FIXME: replace with correct keys
  queryValue: keyof (typeof QueryValues)["offerAge"];
  apiId: EApiOfferAgeId;
}

export const OFFER_AGE: Array<IOfferAgeItemConfig> = [
  {
    apiId: EApiOfferAgeId.ALL,
    queryValue: "offerAge.all",
    translationId: "Všechny",
  },
  {
    apiId: EApiOfferAgeId.MAX_24HOURS,
    queryValue: "offerAge.lessThan24hours",
    translationId: "< 24 hod",
  },
  {
    apiId: EApiOfferAgeId.MAX_3DAYS,
    queryValue: "offerAge.lessThan3days",
    translationId: "< 3 dny",
  },
  {
    apiId: EApiOfferAgeId.MAX_WEEK,
    queryValue: "offerAge.lessThan7days",
    translationId: "< 7 dní",
  },
  {
    apiId: EApiOfferAgeId.MAX_2WEEKS,
    queryValue: "offerAge.lessThan14days",
    translationId: "< 14 dní",
  },
];

export const DEFAULT_OFFER_AGE = OFFER_AGE[0];
